import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import {
    CognitoAuth,
} from 'amazon-cognito-auth-js';


@Injectable({
    providedIn: 'root'
})
export class CognitoAuthService {

    private ORIGINAL_URL_STORAGE_KEY = 'CognitoAuthService.originalUrl';
    private authData: any;
    private cognitoAuth: CognitoAuth;
    private loginUrl: string;
    private cognitoOperation: string;
    private cognitoResolve: any;
    private cognitoReject: any;

    constructor() {
        this.authData = {
            ClientId: environment.cognito_client_id,
            AppWebDomain: environment.cognito_app_web_domain,
            TokenScopesArray: environment.cognito_token_scopes_array,
            RedirectUriSignIn: environment.cognito_redirect_uri_sign_in,
            RedirectUriSignOut: environment.cognito_redirect_uri_sign_out,
            UserPoolId: environment.cognito_user_pool_id,
            AdvancedSecurityDataCollectionFlag: false
        };
        this.cognitoAuth = new CognitoAuth(this.authData);
        this.cognitoAuth.userhandler = {
            onSuccess: (session) => {
                console.log('onCognitoSuccess', this.cognitoOperation, session);
                const isRefresh = this.cognitoOperation === 'refreshAuthToken';
                this.logSuccessfulLogin(isRefresh);
            },
            onFailure: (error) => {
                console.log('onCognitoFailure', this.cognitoOperation, error);
                if (this.cognitoOperation === 'refreshAuthToken') {
                    this.redirectToLoginPage()
                }
                else {
                    this.cognitoReject(error);
                }
            }
        };
        this.loginUrl =
            `https://${this.authData.AppWebDomain}/login?` +
            `client_id=${this.authData.ClientId}` +
            `&response_type=code&scope=${this.authData.TokenScopesArray.join('+')}` +
            `&redirect_uri=${this.authData.RedirectUriSignIn}`;
    }

    public isAuthenticated() {
        return this.cognitoAuth.isUserSignedIn();
    }

    public setOriginalUrl(originalUrl) {
        localStorage.setItem(this.ORIGINAL_URL_STORAGE_KEY, originalUrl);
    }

    public redirectToLoginPage() {
        window.location.href = this.loginUrl;
    }

    public redirectToOriginalUrl() {
        const originalUrl = localStorage.getItem(this.ORIGINAL_URL_STORAGE_KEY);
        window.location.href = originalUrl;
    }

    public logInWithCode() {
        return new Promise((resolve, reject) => {
            this.cognitoOperation = 'logInWithCode';
            this.cognitoResolve = resolve;
            this.cognitoReject = reject;
            this.cognitoAuth.useCodeGrantFlow();
            this.cognitoAuth.parseCognitoWebResponse(window.location.href);
        });
    }

    public refreshAuthToken() {
        const session = this.cognitoAuth.getCachedSession();
        const refreshToken = session.getRefreshToken().getToken();
        return new Promise((resolve, reject) => {
            this.cognitoOperation = 'refreshAuthToken';
            this.cognitoResolve = resolve;
            this.cognitoReject = reject;
            this.cognitoAuth.refreshSession(refreshToken);
        });
    }

    public getIdToken() {
        // Cognito doesn't seem to support access tokens, so we have to use
        // the ID token instead
        return this.cognitoAuth.getCachedSession().getIdToken().getJwtToken();
    }

    private async logSuccessfulLogin(isRefresh) {
        try {
            const token = this.getIdToken();
            const baseUrl = environment.api_base_url;
            const urlPart = `/activity-log/log-user-login`;
            const url = `${baseUrl}${urlPart}`;
            const headers = {
                'Authorization': token,
                'Content-Type': 'application/json'
            };
            const body = {
                is_refresh: isRefresh
            };
            const response = await fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body),
                credentials: 'include'
            });

            if (!response.ok) {
                throw Error();
            }
        }
        catch (ex) {
            console.log('ERROR logging login event');
        }
        finally {
            this.cognitoResolve();
            // resets auto-logout if exists
            localStorage.removeItem('autoLogoutStartTime');
        }
    }

    public logOut() {
        this.cognitoAuth.signOut();
    }
}
